// `dispatch.model_escalated` — the model escalation ladder's per-claim decision
// (`value-objects/llm-credential/escalation.ts`). Its own module because `dispatch.ts`
// sits at the 800-line budget; it joins `DISPATCH_OWN` like every other dispatch kind.

import type { TerminalLine, TerminalRenderContext, TerminalRendered } from '../../../wire/terminal';
import { rec, str } from './dispatch-payload';

/** `{from|to: {model}}` → the model id, or `?` when the row carries none. */
function modelOf(side: Record<string, unknown> | undefined): string {
  return str(side, 'model') ?? '?';
}

export const dispatchModelEscalated = {
  level: 'warn' as const,
  actor: 'system' as const,
  render(ctx: TerminalRenderContext): TerminalRendered | null {
    const input = rec(ctx.row.input);
    const output = rec(ctx.row.output);
    const taskId = str(input, 'taskId');
    const decision = str(output, 'decision');
    if (taskId === undefined || decision === undefined) return null;
    const from = modelOf(rec(output?.['from']));
    const line: TerminalLine =
      decision === 'escalated'
        ? {
            key: 'terminal.dispatch.model_escalated',
            params: { from, to: modelOf(rec(output?.['to'])), via: str(output, 'via') ?? '?' },
          }
        : {
            key: 'terminal.dispatch.model_escalation_skipped',
            params: { from, reason: str(output, 'reason') ?? 'unknown' },
          };
    return { line, subject: { kind: 'task', id: taskId, label: taskId }, refs: { taskId } };
  },
};
